
export class WinnerL3rd {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "WinnerL3rd";
    this.scene = "WinnerL3rd";
    this.data = [];
    this.page = 9009;
  }

  async preview({ options }) {
    this.onAir = false;

    await this.updateData({ options, show: 1 });
    // await this.updateData({ options, show: 2 });
    // await this.updateData({ options, show: 3 });
    // await this.updateData({ options, show: 4 });
    await this.sendPreview("page:read " + this.page);
  }
  async animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }

  async updateData({ options, show }) {
    let xml = await this.getVizPage({ page: this.page, show }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml.payload.field.find((item) => {
        return item.attr.name === "1100";
      }).value = (options?.game?.winner?.first_name.toUpperCase()  || "") + " " + (options?.game?.winner?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1014";
      }).value = options?.game?.winnerby || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "1127";
      }).value = options?.game?.competition?.flag_path + 
      (options?.player?.nationality?.code || "");
      
      let winneromo =
      options?.game?.completed === 1 
      ? 0
      : options?.game?.completed === 2
      ? 1
      : ""

      xml.payload.field.find((item) => {
        return item.attr.name === "2000";
      }).value = winneromo || "";
      

      await this.updateVizPage({
        page: this.page,
        data: xml,
        escape: false,
        show,
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  update({ options }) {}
}
